import {Pipe, PipeTransform} from '@angular/core';
import {PPM_CONTRACT_STATUS} from "../../core/constants";

@Pipe({name: 'ppmContractStatus'})
export class PpmContractStatusPipe implements PipeTransform {

    transform(referralType: number): string {

        switch (referralType) {
            case PPM_CONTRACT_STATUS.ACTIVE:
                return 'Active';
            case PPM_CONTRACT_STATUS.CANCELLED:
                return 'Cancelled';
            default:
                return 'N/A';
        }

    } // transform()

} // ppmContractStatusPipe
